import React, { FC } from 'react';

import { APIS } from '../../../lib/constants/apis';
import FoerderAntragRightSidebar from './right-side-bar/FoerderAntragRightSidebar';
import MittelabrufRightSidebar from './right-side-bar/MittelabrufRightSidebat';
import VerwendungsnachweisRichtSidebar from './right-side-bar/VerwendungsnachweisRichtSidebar';
import ZwischenBerichtRichtSidebar from './right-side-bar/Zwischenbericht';
import AbschlussBerichtRightSidebar from './right-side-bar/AbschlussBerichtRightSidebar';

const AntragRightSideBar: FC<{ api: string }> = ({ api }) => {
	const RenderSidebar = () => {
		if (api === APIS.Antrag) {
			return <FoerderAntragRightSidebar />;
		}
		if (api === APIS.Mittelabruf) {
			return <MittelabrufRightSidebar />;
		}
		if (api === APIS.Verwendungsnachweis) {
			return <VerwendungsnachweisRichtSidebar />;
		}
		if (api === APIS.Zwischenbericht) {
			return <ZwischenBerichtRichtSidebar />;
		}
		if (api === APIS.Abschlussbericht) {
			return <AbschlussBerichtRightSidebar />;
		}
		return <></>;
	};

	return <RenderSidebar />;
};

export default AntragRightSideBar;
